var map = {
	"./benzbmw_en.png": "B69Q",
	"./benzbmw_esp.png": "QDjx",
	"./benzbmw_th.png": "3+7l"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "pgzb";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lucas ^\.\/benzbmw_.*\.png$
// module id = pgzb
// module chunks = 1